import { QHPParentOrganization } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/shared/QHPParentOrganization";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";
import { JSX } from "react";

interface QHPNetworkPillProps {
  onParentOrganizationClick: (parentOrganization: QHPParentOrganization) => void;
  parentOrganization: QHPParentOrganization;
  selected: boolean;
}

const QHPNetworkPill = (props: QHPNetworkPillProps): JSX.Element => {
  return (
    <div
      className={`benchmarking-network-pill d-inline-block ${props.selected && "selected"}`}
      id={`benchmarking-dashboard__network-filters--pill-${props.parentOrganization.parentOrganizationName?.replace(/\W/g, "")}`}
      onClick={() => props.onParentOrganizationClick(props.parentOrganization)}
    >
      <div className="parent-organization-text float-start">
        <div>
          <EllipsisTooltip
            text={props.parentOrganization.parentOrganizationName}
          />
        </div>
        <div className="text-muted">
          <EllipsisTooltip
            text={`Issuer Id: ${props.parentOrganization.issuerIds.join(", ")}`}
          /> 
        </div>
      </div>
      <div className="float-end">
        <span className="fa-stack fa-lg ms-2">
          <i className="fa fa-circle fa-stack-2x h-contract-count-circle" />
          <b className="fa-stack-1x h-contract-count-number">{props.parentOrganization.hContracts.length}</b>
        </span>
      </div>
    </div>
  );
}

export default QHPNetworkPill;
